<template>
  <div class="mt-3">

    <v-row>
      <v-col cols="12" lg="6" class="d-flex flex-column">
        <v-card class="rounded-lg shadow flex d-flex flex-column">
          <v-card-title>
            Conformié par wilaya – Tableau
          </v-card-title>
          <v-divider></v-divider>

          <v-card-text v-if="isLoading">
            <v-skeleton-loader height="300" type="table"/>
          </v-card-text>

          <v-card-text class="flex" v-else>
            <v-data-table
                class="rounded-lg table-border"
                :headers="headers"
                :items="wilayas"
                :items-per-page="5"
            >

              <template v-slot:item.wilaya="{ item }">
               <span class="text-no-wrap font-weight-medium">
                 {{ item.wilaya_name }}
               </span>
              </template>

              <template v-slot:item.validated_count="{ item }">
                <span class="font-weight-medium success--text">
                  {{ item.validated_count }}
                </span>
              </template>

              <template v-slot:item.refused_count="{ item }">
              <span class="font-weight-medium error--text">
                {{ item.refused_count }}
              </span>
              </template>

              <template v-slot:item.total="{ item }">
                <span class="font-weight-medium">
                  {{ item.total }}
                </span>
              </template>


              <template v-slot:item.percent_validated="{ item }">
                <v-progress-linear stream striped
                                   style="min-width: 100px"
                                   :value="item.percent_validated"
                                   height="15"
                                   color="success"
                                   rounded
                >
                  <strong class="white--text">
                    {{ Math.round(item.percent_validated) }}%
                  </strong>
                </v-progress-linear>
              </template>

            </v-data-table>

          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" lg="6" class="d-flex flex-column">
        <v-card tile
                class="shadow flex d-flex flex-column"
                :class="fullscreen ?  'fullscreen-card': 'rounded-lg'"
        >
          <v-card-title>
            Conformié par wilaya – Carte
            <v-spacer/>
            <v-btn icon @click="fullscreen = !fullscreen">
              <v-icon>{{ fullscreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen' }}</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text v-if="isLoading">
            <v-skeleton-loader height="300" type="image,article"/>
          </v-card-text>

          <v-card-text class="flex" v-else>
            <DZSVG3 :wilayas="wilayas"/>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";
import DZSVG3 from "@/views/opus/dashboard/components/DZSVG3";

export default {
  props: ['opus_campaign_id'],
  components: {
    DZSVG3
  },
  data() {
    return {
      fullscreen: false,
      isLoading: false,
      headers: [
        {text: 'Wilaya', value: 'wilaya'},
        {text: 'Validés', value: 'validated_count'},
        {text: 'Refusés', value: 'refused_count'},
        {text: 'Total', value: 'total'},
        {text: 'Pourcentage validés (%)', value: 'percent_validated'},
      ],
      wilayas: [],
    }
  },
  methods: {
    complianceByWilaya() {
      this.isLoading = true
      if (!this.opus_campaign_id) return;
      HTTP.get('/v1/opus/dashboard/compliance-by-wilaya', {
        params: {
          opus_campaign_id: this.opus_campaign_id
        }
      }).then(res => {
        this.isLoading = false
        this.wilayas = res.data.data
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
  },
  created() {
    this.complianceByWilaya()
  },
  watch: {
    opus_campaign_id(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.complianceByWilaya();
      }
    }
  }
}
</script>

<style>
.fullscreen-card {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  background-color: white;
  overflow: auto;
}
</style>